// one can add a file or YT-Video


export function addFileUploaderToTask(){
    $(".add-file-to-task").on("click", function(){
        openModal();
    })
    addListeners();
}

function openModal(){
        const content = '<div class="mb-2"><input type="text" class="form-control" id="file-name" placeholder="Bezeichnung"></div>';

        const submitBtn = {
            text: "Hochladen",
            class: "upload-file-to-task"
        }

        const exists = document.getElementById("add-file-to-task") !== null;
        

        const modal = makeModal("add-file-to-task", "Datei hochladen", content, submitBtn, true, 'sm', true);

        if (!exists){
            const html = '<div id="dropzone-wrapper" class="px-2">' +
            '<form id="add-file-task" class="dropzone dz-clickable ml-4 mr-4 d-flex justify-content-center align-items-center" action="/upload">' +
            '<div class="dz-default dz-message mt-1 mb-1">' +
            '<div class="dz-details"><div class="dz-filename"><span data-dz-name></span></div></div>' + 
            '<button class="btn btn-info btn-circle btn-xl me-1 mb-1 upload-info"' +
        'type="button"><i class="fa fa-upload"></i></button>' +
        '<center>' +
        '<span class="upload-title">Hochladen</span>' +
        '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' +
        '<div class="dz-error-message"><span data-dz-errormessage></span></div>' +
        '</center>' +
        '</div>' +
        '</form></div>';
            $("#add-file-to-task").find(".modal-body").after(html);
            
            const dropzone = addDropzone();
            // addListeners();

        }

        

        modal.show();
}

function getExt(string:string){
    const parts = string.split(".");
    const ext = parts[parts.length - 1];
    return ext.toLowerCase();
}

function addListeners(){
    const filesWrapper = $("#files-wrapper");
    filesWrapper.on("click", ".remove-task-answer-item", function(){
        $(this).parents(".task-answer-item").remove();
    })
    filesWrapper.on("click", ".edit-answer-item", function(){
        const url = $(this).parents(".task-answer-item").attr('data-url');
        const name = $(this).parents(".task-answer-item").find(".task-file-name").html();
        const ext = getExt(url);
        if (url !== undefined){
            const images = ["png", "jpeg", "jpg"];
            if (images.includes(ext)){
                let content = '<div class="mb-2"><input id="item-name" type="text" value="'+name+'" class="form-control"></div>'
                content += '<div id="answer-item-showcase" class="text-center mt-2"><img src="' + url +'" style="max-width: 95%; max-height: 400px;"></div>';
                
                const submitBtn = {
                    text: "Speichern",
                    class: "edit-answer-item-save"
                }

                const modal = makeModal("show-answer-item", "Item anzeigen", content, submitBtn);
                modal.show();
            } else if (ext == "pdf"){
                window.open(url, "_blank");
            }
        }
    })
    $(document).on("click", ".edit-answer-item-save", function(){
        const name = $("#item-name").val();
        
        const url = $("#answer-item-showcase").find("img").attr('src');
        const items = $(".task-answer-item");
        items.each(function(ind, obj){
            if (url == $(obj).attr('data-url')){
                $(obj).find(".task-file-name").html(name);
            }
        });
        hideModal("show-answer-item");
    });
}

function changeDisplayFileName(newName:string){
  //  $(".dz-filename").find("span").html(newName); // potentially problematic
    $(".upload-title").html(newName);
}

interface AddItem {
    name: string;
    url: string;
    type: string;
}

export function renderFile(item:AddItem){
    addFileToTask(item.name, item.url, item.type);
}

function addFileToTask(filename:string, url:string, ext:string){
    const icon = insertIcon(ext);
    const html = '<div class="d-flex align-items-center m-f-t-item mb-1 task-answer-item" data-url="'+url+'" data-type="' + ext + '">' +
    '<div class="font-weight-medium"><i class="' + icon +'"></i> <span class="task-file-name">'+ filename +'</span></div>' +
    '<div class="ms-auto">'+
    '<button type="button" class="btn btn-light-info text-info font-weight-medium waves-effect edit-answer-item me-1" data-bs-toggle="tooltip" data-bs-original-title="Bearbeiten">'+
    '<i class="fa fa-edit"></i></button>' +
    '<button type="button" class="btn btn-light-danger text-danger font-weight-medium waves-effect remove-task-answer-item" data-bs-toggle="tooltip" data-bs-original-title="Löschen"><i class="fa fa-trash"></i></button></div>'
    +'</div>'
    $("#files-wrapper").append(html);
}

function insertIcon(type:string){
    const images = ["png", "jpeg", "jpg"];
    const pdf = "pdf";
    if (images.includes(type)){
        return "mdi mdi-image"
    } else if (type == pdf){
        return "mdi mdi-file-pdf"
    } else {
        return "mdi mdi-book-open"
    }
}

function addDropzone(){
    const dropzone = new Dropzone('form#add-file-task', {
        maxFilesize: 5,
        autoQueue: false,
        acceptedFiles: ".png,.jpeg,.jpg,.pdf,.PNG,.JPEG,.JPG,.PDF",
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        init: function(){
            const dz = this;
            
            $(".upload-file-to-task").on("click", function(e){
                e.preventDefault();
                const files = dz.files;
                let sent = false;
                files.forEach((file) => {
                    if (file.status == "queued"){
                        sent = true;
                    }
                })
                if (sent){
                    showSpinner($(this));
                    dz.processQueue();
                } else {
                    errorToast("Bitte füge erst eine Datei hinzu");
                }
            })
            dz.on("complete", function(file){
                
            })
            dz.on("success", function(file, response){
                const url = response.path;
                const filename = $("#file-name").val();
                const urlParts = url.split(".");
                const ext = urlParts[urlParts.length - 1];
                successToast("Datei wurde hinzugefügt", "Erfolg", 4500, true);
                hideSpinner($(".upload-file-to-task"))
                hideModal("add-file-to-task");
                $(".upload-info").addClass("btn-info").removeClass("btn-success");
                $(".upload-title").html("Datei hochladen");
                addFileToTask(filename, url, ext);
                dz.removeAllFiles( true );
            })
            dz.on("error", function(one, two){
                errorToast("Konnte nicht hochgeladen werden");
            })
        },     
        addedfile: function(file){
            const parts = file.name.split(".");
            const name = parts[parts.length - 2];
            const currentName = $("#file-name").val();
            if (currentName == ''){
                $("#file-name").val(name);
            }
            $(".upload-info").addClass("btn-success").removeClass("btn-info");
            const files = this.files;
            files.forEach((f) => {
                f.status = "queued";
            })
            $(".upload-title").html("Bereit");
        },

    })
    return dropzone;
}